import React from 'react'
import styled from 'styled-components'
import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import Articles from './Articles'
import TwitterFeed from './TwitterFeed'

const Container = styled.div`
  display: flex;

  @media screen and (max-width: 850px) {
    display: block;
  }
`

const MainContainer = styled.div`
  flex: 3;
`

const SideContainer = styled.div`
  flex: 1;
  padding-left: 2rem;

  @media screen and (max-width: 850px) {
    padding-left: 0;
  }
`

export default () => (
  <Query
    render={({ content, articles }) => (
      <Layout>
        <Hero>
          <HeroTitle useH1>{content.title}</HeroTitle>
        </Hero>
        <Container>
          <MainContainer>
            <Articles articles={articles} />
          </MainContainer>
          <SideContainer>
            <TwitterFeed
              viewMore={content.view_more}
              timeline={content.twitter_timeline}
            />
          </SideContainer>
        </Container>
      </Layout>
    )}
  />
)
